import styled from 'styled-components';

import { ACQ, COLORS, MOBILE } from '@/nova/theme/tokens';

/**
 * Wraps the whole "This month's Overview" section (title + KPI grid + summary aside) in the same
 * rounded outer panel the acquisition "Lumio Channels" block uses (`ACQ.cardOuter`, 16px radius),
 * so the overview reads as one contained card instead of free-floating on the page background.
 */
export const OverviewCard = styled.div`
  background: ${ACQ.cardOuter};
  border-radius: 16px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/**
 * Two titled halves: the "This month's Overview" KPIs (left) beside the "Your Affiliates" summary
 * (right). `align-items: stretch` so both columns share a height (the aside fills to match the KPI
 * grid); stacks on mobile.
 */
export const OverviewLayout = styled.div`
  display: grid;
  /* 50/50: the KPI 2x2 grid on the left, the summary/SSO card on the right. */
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

/** The left half: its own section title above the KPI grid, so the title scopes to these KPIs
 *  rather than spanning the whole block (which read as if it covered the affiliates summary too). */
export const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const AsideSlot = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* Hairline separating the "This month's Overview" half (left) from the "Your Affiliates" half
     (right). Centered in the gutter: the 16px column gap sits to its left, this 16px padding to its
     right. Runs the full column height, alongside both the title and the card. */
  border-left: 1px solid ${COLORS.hairline};
  padding-left: 16px;

  ${MOBILE} {
    /* Stacked: the divider moves above the summary instead of beside it. */
    border-left: none;
    padding-left: 0;
    border-top: 1px solid ${COLORS.hairline};
    padding-top: 16px;
  }
`;

/** Wraps the summary card under the "Your Affiliates" title and flexes to fill the remaining column
 *  height, so the card matches the KPI grid's height instead of shrinking to its content. */
export const AsideBody = styled.div`
  flex: 1;
  min-height: 0;
`;
